import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import usePageTracking from './hooks/usePageTracking';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import BackgroundShapes from './components/BackgroundShapes';
import './App.css';

// Lazy loading de componentes
const Home = React.lazy(() => import('./pages/Home'));
const Productos = React.lazy(() => import('./pages/Productos'));
const Servicios = React.lazy(() => import('./pages/Servicios'));
const Nosotros = React.lazy(() => import('./pages/Nosotros'));
const Contacto = React.lazy(() => import('./pages/Contacto'));
const Login = React.lazy(() => import('./pages/Login'));
const Setup = React.lazy(() => import('./pages/Setup'));
const Admin = React.lazy(() => import('./pages/Admin'));

const LoadingSpinner = () => (
  <div className="loading-spinner">
    <div className="spinner"></div>
    <p>Cargando...</p>
  </div>
);

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

const AppContent = () => {
  usePageTracking();

  return (
    <div className="app">
      <Navbar />
      <main className="main-content">
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/productos" element={<Productos />} />
            <Route path="/servicios" element={<Servicios />} />
            <Route path="/nosotros" element={<Nosotros />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/login" element={<Login />} />
            <Route path="/administracion" element={<Login />} />
            <Route path="/setup" element={<Setup />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
